import { PodcastCard } from './components/PodcastCard';

import { LoaderElement } from '../shared/loaderElement/LoaderElement';
import { SectionElement } from '../shared/sectionElement/SectionElement';
import type { PodcastsElementProps } from './PodcastsElement.types';

export function PodcastsElement(props: PodcastsElementProps) {
  const { translations, children, element, isLoading, getPodcastHref } = props;
  const { data } = element.attrs || {};
  const shows = data?.shows || [];

  if (isLoading) {
    return (
      <SectionElement
        title={translations?.['manage.podcasts.title'] || 'Your podcasts'}
        subTitle={
          translations?.['manage.podcasts.description'] || 'Choose a podcast to add to your favorite podcast app'
        }
      >
        <LoaderElement count={2} />
      </SectionElement>
    );
  }

  if (shows.length === 0) {
    return null;
  }

  const hasInactiveShows = shows.some((show) => !show.isActive);

  return (
    <SectionElement
      title={translations?.['manage.podcasts.title'] || 'Your podcasts'}
      subTitle={translations?.['manage.podcasts.description'] || 'Choose a podcast to add to your favorite podcast app'}
    >
      {hasInactiveShows && (
        <div className="mb-4 p-4 rounded-md bg-yellow-50 border border-yellow-200">
          <p className="text-sm text-yellow-800">
            {translations?.['manage.podcasts.inactive_message'] ||
              'Your subscription is inactive. Reactivate to access podcast feeds.'}
          </p>
        </div>
      )}
      <div className="space-y-4">
        {shows.map((show) => (
          <PodcastCard key={show.id} data={show} translations={translations ?? {}} href={getPodcastHref?.(show.id)} />
        ))}
      </div>
      {children}
    </SectionElement>
  );
}
